
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMediaLive as ObiMediaLiveElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-media-live.js';
 
 
 

 
 export const ObiMediaLive = createComponent({
   react: React,
   tagName: 'obi-media-live',
   elementClass: ObiMediaLiveElement,
   events: {
     
   }
  });
 
 